"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tap_stream_1 = require("../../client/impl/frame/tap-stream");
exports.TapStreamReader = tap_stream_1.TapStreamReader;
exports.TapStreamWriter = tap_stream_1.TapStreamWriter;
